import React from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "../ui/Dropdown";
import { useAuthContext } from "../AuthContext";

type ProfileDropdownProps = {
  onLogout?: () => void;
};

const ProfileDropdown = ({ onLogout }: ProfileDropdownProps) => {
  const { userInfo } = useAuthContext();
  const navigate = useNavigate();
  const displayName = userInfo?.first_name || "관리자";

  return (
    <React.Fragment>
      <Dropdown className="w-full px-2">
        <DropdownToggle
          tag="button"
          type="button"
          className="flex w-full items-center justify-center gap-3 rounded-md bg-transparent border-0 px-3 py-2 text-slate-300 shadow-none outline-none transition-colors hover:bg-slate-800"
        >
          <span className="flex shrink-0 h-8 w-8 items-center justify-center rounded-full bg-slate-700 text-slate-200">
            <i className="ri-user-3-line text-base"></i>
          </span>
          <span className="profile-name-text hidden flex-1 text-left leading-tight md:block">
            <span className="block text-sm font-medium text-slate-200">{displayName}</span>
          </span>
        </DropdownToggle>
        <DropdownMenu end className="z-[1101]" style={{ width: '14rem' }}>
          <DropdownItem header className="truncate">{`Welcome ${displayName}!`}</DropdownItem>
          <DropdownItem onClick={() => navigate('/profile')}>
            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">Profile</span>
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem onClick={onLogout}>
            <i className="ri-logout-box-r-line text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">Logout</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default ProfileDropdown;
